import { createActionGroup, props } from '@ngrx/store';
import { ApplicationConfiguration } from './application-configuration.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ApplicationConfigurationResolverActions = createActionGroup({
  source: 'ApplicationConfiguration Resolver',
  events: {
    'Configuration Requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ApplicationConfigurationApiActions = createActionGroup({
  source: 'ApplicationConfiguration API',
  events: {
    'Configuration Loaded': props<{ configurations: ApplicationConfiguration[] }>(),
    'Configuration Loaded Error': props<{ error: ErrorModel }>(),
  },
});
